import { createContext } from 'react'
import type { Auth0ContextInterface } from '@auth0/auth0-react'

export const Auth0Context = createContext<Auth0ContextInterface | undefined>(undefined)
